import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Paper,
  FormControl,
  RadioGroup,
  Stack,
  Card,
  CardActionArea,
  Radio,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PaymentsIcon from "@mui/icons-material/Payments";
import { translate } from "../../i18n/customI18nProvider";
import { notifyError } from "../../util";
import twintLogo from "../../images/twint-logo.png";

export const SelectPaymentModal = ({ methods, open, onClose, onSelect }) => {
  const [value, setValue] = React.useState("");
  const METHODS_ORDER = ["twint", "card"];

  const getMethods = () => {
    if (!methods || methods.length === 0) return [];

    let filteredMethods = [...methods];

    if (methods.includes("twint") && methods.includes("twint_direct")) {
      filteredMethods = filteredMethods.filter((m) => m !== "twint");
    }

    const finalMethods = filteredMethods.map((method) => ({
      key: method === "twint_direct" ? "twint" : method,
      value: method,
    }));

    finalMethods.sort((a, b) => {
      const indexA = METHODS_ORDER.indexOf(a.key);
      const indexB = METHODS_ORDER.indexOf(b.key);
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });

    return finalMethods;

  };

  useEffect(() => {
    if(open && (!methods || methods.length === 0)) {
      notifyError("Aucune méthode de paiement disponible. Veuillez réessayer plus tard.");
      onClose();
    }
  }, [open]);

  const getIcon = (key) => {
    switch (key) {
      case "card":
        return CreditCardIcon;
      case "twint":
        return twintLogo;
      default:
        return PaymentsIcon;
    }
  };

  const handleChange = (method) => {
    setValue(method);
  }

  const handleConfirm = () => {
    if (value) {
      onSelect(value);
    } else {
      notifyError(translate('custom.please_select_payment_method'));
    }
  }

  const OptionCard = ({ method, label, logo, isIcon = false }) => {
    const checked = value === method;

    return (
      <Card variant="outlined" sx={{ borderWidth: checked ? 2 : 1, borderColor: checked ? 'primary.main' : 'divider'}}>
        <CardActionArea onClick={() => handleChange(method)}>
          <Box sx={{
              display: 'flex',
              alignItems: 'center',
              p: 2,
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center" flex={1}>
              {isIcon ? (
                React.createElement(logo, { sx: { fontSize: "40px" } })
              ) :
                <Box
                  component="img"
                  src={logo}
                  alt={label}
                  sx={{ width: 40, height: 40, objectFit: 'contain' }}
                />
              }
              <Typography variant="h6">{label}</Typography>
            </Stack>

            <Radio checked={checked} />
          </Box>
        </CardActionArea>
      </Card>
    );
  };

  return (
    <Dialog fullWidth={true} open={open} onClose={onClose} PaperProps={{ sx: { position: 'absolute', top: 16, m: 0 } }}>
        <DialogTitle>{translate('custom.select_payment_method')}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <RadioGroup value={value}>
              <Stack spacing={2}>
                {
                  getMethods().map((method) => (
                    <OptionCard
                      key={method.value}
                      method={method.value}
                      label={translate('custom.' + method.key)}
                      isIcon={method.key !== "twint"}
                      logo={getIcon(method.key)}
                    />
                  ))
                }
              </Stack>
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>{translate('custom.cancel')}</Button>
            <Button onClick={handleConfirm} disabled={value === ""} variant="contained">{translate('custom.confirm')}</Button>
        </DialogActions>
    </Dialog>
  );
};